import React, {useEffect, useState} from 'react';
import {searchPageByIntercept} from '@/api/conversation';
import {getSensitiveHitById, sensitiveHitUserInfo} from '@/api/sensitiveHit';
import Content from '@/page/conversation/InterceptConPage/Content';

export default function InterceptViewConPage() {
    useEffect(() => {
        init();
    }, []);
    const [data, setData] = useState(null);
    const [page, setPage] = useState(null);
    const [receive, setReceive] = useState(null);

    function getReceive(receiveType, value) {
        let receive = null;
        if (receiveType == 1) receive = value.to1;
        if (receiveType == 0) receive = value.to2;
        if (receiveType == 3) receive = value.sysRoom;
        setReceive(receive);
    }

    function init() {
        let path = window.location.href.split('?')[1];
        let id = path.split('=')[1];
        setData(null);
        setReceive(null);
        getSensitiveHitById(id).then(res => {
            let intercept = res.data;
            searchPageByIntercept(intercept.id, 10).then(res => {
                setPage(res.data);
                let postData = {
                    roomId: intercept.roomId,
                    fromId: intercept.fromId,
                    toId: intercept.toId,
                };
                console.log(postData);
                sensitiveHitUserInfo(postData).then(res => {
                    setData(res.data);
                    getReceive(res.data.receiveType, res.data);
                });
            });
        });
    }

    function renderContent() {
        return (
            <div style={{overflowY: 'auto', height: '90vh', width: '100%', background: '#F8F8F8'}}>
                <Content
                    size={10}
                    receiveType={data.receiveType}
                    receive={receive}
                    from={data.from}
                    currentPage={page}
                />
            </div>
        );
    }

    return <div>{data && receive && renderContent()}</div>;
}
